import { pipe, prop } from 'ramda';
import { withProps, compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import OrangeButton from './OrangeButton';

const shouldShow = pipe(
  getPOSData,
  prop('limitExceeded'),
);

const mapStateToProps = state => ({
  hidden: shouldShow(state),
});

const visibilityCheck = branch(
  ({ hidden }) => hidden,
  renderNothing,
);

const MYADS_URL = 'https://www3.olx.com.br/account/userads';
const isInsertion = () => document.location.search.match(/action=insertion/);

const configureTarget = withProps({
  type: 'secondary',
  href: isInsertion() ? `${MYADS_URL}?under_review=1` : MYADS_URL,
  'data-e2e': 'exitButton',
});

export default compose(
  connect(mapStateToProps),
  configureTarget,
  visibilityCheck,
)(OrangeButton);
